/**
 * @class reportFilter.
 *
 */
import { kebabCase, includes } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../common/containers/icon';
const addFilterProperty = (incomingStr, filterLabelName) => {
  let str = incomingStr;
  if (!includes(str, filterLabelName)) {
    // if (!str.includes(filterLabelName)) { // not IE11 compatible
    str += (str.length > 0 ? ', ' : '') + filterLabelName;
  }
  return str;
};
const filterString = reportFilter => {
  const properties = {
    jobPhaseCodes: 'Job Phase Codes',
    currentStates: 'Current States',
    reportAssignments: 'Assigned To',
    organizations: 'Organizations',
    reportTypes: 'Report Types',
    assetCategoryNames: 'Asset Categories',
    assetTypes: 'Asset Types',
    assets: 'Assets',
    jobs: 'Jobs',
    pieces: 'Pieces',
    pieceOthers: 'Pieces',
    reportTags: 'Report Tags',
    statuses: 'Report Statuses',
    weekEnding: 'Week Ending',
    creators: 'Creators',
    issueSeverities: 'Issue Severities'
  };
  let result = '';
  Object.keys(properties).map(prop => {
    const filterLabelName = properties[prop];
    if (reportFilter[prop] && reportFilter[prop].length > 0) {
      result = addFilterProperty(result, filterLabelName);
    }
    return result;
  });

  // process forms separately...
  if (reportFilter.forms !== undefined && reportFilter.forms.length > 0) {
    // loop over each form and add the FormType
    // associated with it.
    reportFilter.forms.forEach(form => {
      const {
        content: contentStr
      } = form;
      const content = JSON.parse(contentStr);
      const {
        formType: {
          name
        } = {}
      } = content;
      if (name !== undefined) {
        result = addFilterProperty(result, name);
      }
    });
  }
  return result;
};
const ReportFilter = ({
  reportFilter,
  onRemove,
  onSelect
}) => {
  const clearStyle = {
    clear: 'both'
  };
  const handleSelect = () => onSelect(reportFilter);
  const handleRemove = () => onRemove(reportFilter);
  return /*#__PURE__*/React.createElement("div", {
    className: `reportFilter boldOnHover t-rf-${kebabCase(reportFilter.name)}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-rf-name",
    onClick: handleSelect,
    onKeyPress: handleSelect,
    role: "link",
    tabIndex: 0
  }, reportFilter.name), /*#__PURE__*/React.createElement("span", {
    "aria-label": "report-filter-remove",
    className: "float-md-right brandPrimary t-rf-delete",
    onClick: handleRemove,
    onKeyPress: handleRemove,
    role: "link",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  })), /*#__PURE__*/React.createElement("div", {
    className: "t-rf-summary",
    onClick: handleSelect,
    onKeyPress: handleSelect,
    role: "link",
    style: clearStyle,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("small", null, filterString(reportFilter))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    style: clearStyle
  }));
};
ReportFilter.propTypes = {
  onRemove: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  reportFilter: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};
export default ReportFilter;